import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { formatCollectionAndFieldName } from './common/common_utils';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class DirectusCollections extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    directusCollections: null,
  };
  async componentDidMount() {
    const { match, actions } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    await actions.loadExternalDatabaseForDirectus({ projectId, externalDbUuid, version });
    await actions.collectionListExternaldbs({ projectId, dbUuid: externalDbUuid, version });
  }
  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  formatDate = (date) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    };
    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const ordinalSuffix = this.getOrdinalSuffix(day);
    return formattedDate.replace(/\b\d+\b/, (match) => match + ordinalSuffix);
  };
  handleContinueButtonClick = () => {
    const { match, actions, history } = this.props;
    const { externalDbUuid, projectId, version } = match.params;
    history.push(
      `/2.0/data-connector/${version}/v/${projectId}/directus-datasource/${externalDbUuid}/create`,
    );
  };
  renderCollectionCards = (item, index) => {
    const { collectionList } = this.props.dataConnector;
    const name = item.name;
    const matchingObject =
      collectionList && collectionList.find((obj) => obj.orgCollectionName === name);
    return (
      <span className={`card  ml-4 col-lg-4 d-flex`} key={index}>
        <div className="card-body">
          <div className="avatar__meta">
            {matchingObject && matchingObject ? (
              <h5 className="avatar__title js-user-name" title={item.name}>
                {item.name} <i className={'wb webconnect-check-circle text-success'}></i>
              </h5>
            ) : (
              <h5 className="avatar__title js-user-name" title={item.name}>
                {item.name}
              </h5>
            )}
            {item && item.fields ? (
              <p>Number of fields: {Object.keys(item.fields).length}</p>
            ) : (
              <p>Number of fields: 0</p>
            )}
            {matchingObject && matchingObject ? (
              <div>
                <p>Created At: {this.formatDate(new Date(matchingObject.createdAt))}</p>
                <p>Updated At: {this.formatDate(new Date(matchingObject.updatedAt))}</p>
              </div>
            ) : (
              <div>
                <p>Created At: Not yet created</p>
                <p>Updated At: Not yet updated</p>
              </div>
            )}
          </div>
        </div>
      </span>
    );
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }
    const { externalDbDirectus, loadExternalDatabaseForDirectusPending } = this.props.dataConnector;
    if (loadExternalDatabaseForDirectusPending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={loadExternalDatabaseForDirectusPending}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    const allColname = externalDbDirectus ? externalDbDirectus.completeData.tables : null;
    return allColname ? (
      <CommonPageComponent>
        <ParentContentCard title={' List of Collections via Directus'} icon={'collection'}>
          <div className="d-flex flex-wrap">
            {allColname &&
              allColname.map((item, index) => {
                return this.renderCollectionCards(item, index);
              })}
          </div>
          {allColname && allColname.length > 0 && (
            <div className="card-footer flex-end">
              <button
                className="btn btn-theme-submit mt-3 float-right"
                onClick={this.handleContinueButtonClick}
              >
                <i className="wb webconnect-rocket"></i>
                &nbsp;Continue&nbsp;
              </button>
            </div>
          )}
        </ParentContentCard>
      </CommonPageComponent>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DirectusCollections);
